import { useQuery, useSuspenseQuery } from '@tanstack/react-query';
import { getCommonProcessYn, getPtCardInfo, getPtCardInfoToCommonProcess } from '../api';
import { QUERY_KEYS } from '../consts';

export const useSuspensePtCardInfo = (params) => {
  return useSuspenseQuery({ queryKey: [QUERY_KEYS.commonProcessYn], queryFn: () => getCommonProcessYn(params) });
};

export const useGetPtCardInfo = (params, commonProcessYn) => {
  return useQuery({
    queryKey: [QUERY_KEYS.ptCardInfo],
    queryFn: () => {
      return commonProcessYn === 'Y' ? getPtCardInfoToCommonProcess(params) : getPtCardInfo(params);
    },
  });
};
